import React from 'react';
import FormattedCurrency from '../../format-currency/FormattedCurrency';
import { useCssHandles } from '../../../utils/functions';

import { useCurrentSeller } from '../SellerBody/CurrentSellerContext';
import { useSellerContext } from '../SellerBody/SellerContext';

const SELLERS_CSS_HANDLES = ['sellerPriceShipping', 'sellerPriceShippingText'] as const;

function SellerPriceWithShipping({ componentId, blockClass }: any) {
	const { currentSeller, shipping } = useCurrentSeller();
	const { limitShownShippingInformation } = useSellerContext();
	const { handles }: any = useCssHandles(`vtex-seller-selector-0-x`, SELLERS_CSS_HANDLES, blockClass);

	return (
		<div
			data-selection={componentId}
			className={`${handles.sellerPriceShipping} ma0 items-center tc br2 ph6 pv4 ma0 w-100-s w-20-m`}
		>
			{shipping
				? shipping.slas.slice(0, limitShownShippingInformation).map((sla, index: number) => (
						<p key={index} className={`${handles.sellerPriceShippingText} ma0`}>
							<FormattedCurrency
								baseCssHandle={`vtex-seller-selector-0-x`}
								value={sla.price / 100.0 + (currentSeller ? currentSeller.commertialOffer.Price : 0)}
							/>
						</p>
					))
				: `Digite o CEP para calcular`}
		</div>
	);
}

export default SellerPriceWithShipping;
